
export default {
  statuses: [
    { id: 0, name: 'inactive' },
    { id: 1, name: 'active' },
  ]
};
